// Copyright 2020 The Nakama Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface Group {
  id: string;
  creator_id: string;
  name: string;
  description?: string;
  lang_tag?: string;
  metadata?: string;
  avatar_url?: string;
  open: boolean;
  edge_count: number;
  max_count: number;
  create_time: string;
  update_time: string;
}

export interface GroupList {
  groups: Group[];
  cursor?: string;
}

export interface GroupUser {
  user: {
    id: string;
    username?: string;
    display_name?: string;
    avatar_url?: string;
    lang_tag?: string;
    location?: string;
    timezone?: string;
    metadata?: string;
    create_time: string;
    update_time: string;
  };
  state: number;
}

export interface GroupUserList {
  group_users: GroupUser[];
  cursor?: string;
}

export interface GroupSearchFilters {
  name?: string;
  lang_tag?: string;
  members?: number;
  open?: boolean;
}

export interface GroupUserSearchFilters {
  state?: number;
  cursor?: string;
}

export interface CreateGroupRequest {
  name: string;
  description?: string;
  lang_tag?: string;
  avatar_url?: string;
  open?: boolean;
  max_count?: number;
  metadata?: string;
}

export interface UpdateGroupRequest {
  group_id: string;
  name?: string;
  description?: string;
  lang_tag?: string;
  avatar_url?: string;
  open?: boolean;
  max_count?: number;
  metadata?: string;
}

export interface DeleteGroupRequest {
  group_id: string;
}

export interface AddGroupUsersRequest {
  group_id: string;
  user_ids: string[];
}

export interface RemoveGroupUsersRequest {
  group_id: string;
  user_ids: string[];
}

export interface PromoteGroupUsersRequest {
  group_id: string;
  user_ids: string[];
}

export interface DemoteGroupUsersRequest {
  group_id: string;
  user_ids: string[];
}

export interface BanGroupUsersRequest {
  group_id: string;
  user_ids: string[];
}

export interface KickGroupUsersRequest {
  group_id: string;
  user_ids: string[];
}

export enum GroupUserState {
  SUPERADMIN = 0,
  ADMIN = 1,
  MEMBER = 2,
  JOIN_REQUEST = 3,
  BANNED = 4
}

export interface GroupActivity {
  id: string;
  group_id: string;
  user_id: string;
  username?: string;
  action: string;
  metadata?: string;
  create_time: string;
}

export interface GroupActivityList {
  activities: GroupActivity[];
  cursor?: string;
}
